import React from 'react';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import { useMutation } from '@apollo/client';
import { DELETE_USER_CONFIRM } from '../../../../graphql/userConfirm/userAddress/mutation';
import { useToasts } from 'react-toast-notifications';

const DeleteReceiveAddress = ({ userAddress, onClose, setDeleteReceiveModal }) => {
    const { addToast } = useToasts();

    const [deleteUserAddress_API] = useMutation(DELETE_USER_CONFIRM);
    const confirmDelete = async () => {
        try {
            const response = await deleteUserAddress_API({
                variables: {
                    where: {
                        id: userAddress?.value?.id,
                        user: userAddress?.value?.user
                    }
                }
            });
            if (response?.data?.delUserAddress?.message === "Success") {
                onClose();
                addToast("ການລົບ ທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ສຳເລັດ", {
                    appearance: "success",
                    autoDismiss: true,
                });
            }
        } catch (error) {
            console.log(error);
            onClose();
            addToast("ຫລົມເຫລວການລົບ ທີ່ຢູ່ສຳລັບການຈັດສົ່ງ ກະລຸນາລອງໃຫມ່ພາຍຫລັງ!", {
                appearance: "error",
                autoDismiss: true,
            });
        }

    };

    return (
        <>
        {_.isEmpty(userAddress) ? (<p>Loading...</p>) : (
            <div>
            <p>!ທ່ານຕ້ອງການລົບທີ່ຢູ່ສຳລັບການຈັດສົ່ງ</p>
            <div className="d-flex align-items-center">
                <div className="me-3">
                <img
                    src={userAddress?.value?.img ? userAddress?.value?.img : null}
                    style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover' }}
                    alt={userAddress?.value?.deliveryName}
                    className="rounded-circle"
                />
                </div>
                <div>
                <p className="fw-bold mb-1" style={{ fontSize: '0.95rem' }}>
                    {userAddress?.value?.deliveryName}: {userAddress?.value?.userName}-{userAddress?.value?.userTel}-{userAddress?.value?.address || "Name not found..."}
                </p>
                {/* <small className="text-muted">{userAddress?.value?.additionalInfo}</small> Optional: Extra details */}
                </div>
            </div>
    
            {/* //TODO Cancel Button */}
            <Button 
                onClick={() => setDeleteReceiveModal(false)} 
                variant="danger" 
                style={{marginRight: '2px'}}
            >
                ຍົກເລີກ
            </Button>
                    
            {/* //TODO Confirm Button */}
            <Button 
                onClick={() => confirmDelete()} 
                variant="success"
                style={{ right: '12px'}}
            >
                ຢືນຢັນການລົບ
            </Button>
            </div>
        )}
        </>
    );
};

export default DeleteReceiveAddress;